module.exports = __webpack_public_path__ + "static/media/simpleCollection.2fdfa373.jpg";